import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { O5UpsertEnvironmentDrawer } from '../../../../../../../features/o5/environment/o5-environment-upsert-drawer';
import { type O5EnvironmentCustomTableHeaderProps, O5EnvironmentsTable } from '../../../../../../../features/o5/environment/o5-environments-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/environment/_environment/')({
  head: () => getPageHead('Environments'),
  component: O5EnvironmentList,
});

function TableHeader({ filter, search }: O5EnvironmentCustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <O5UpsertEnvironmentDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Upsert Environment" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      </HorizontalStack>

      {search}
    </VerticalStack>
  );
}

function O5EnvironmentList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5EnvironmentsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
